import { Reducer } from "redux";

import { SagaWithReturnType } from "@multiweb/types/react";

/**
 * Vrátí funkci pro vytvoření typu akce v závislosti na modulu.
 * @param moduleName Název modulu vlastnící akci
 */
export const createCreateActionType = <NS extends string>(moduleName: NS) => (
    /**
     * Vytvoří typ akce v závislosti na modulu.
     * @param actionType Typ identifikující akci
     */
    <N extends string>(actionType: N) => `${moduleName}/${actionType}` as `${NS}/${N}`
);

/**
 * Vrátí funkci pro vytvoření klíče načítání pro fetching modul v závislosti na modulu.
 * @param moduleName Název modulu vlastnící načítaná data
 */
export const createCreateFetchingKey = (moduleName: string) => (
    /**
     * Vytvoří klíč načítání pro fetching modul v závislosti na modulu.
     * @param fetchingKey Klíč identifikující načítání.
     */
    (fetchingKey: string) => `${moduleName}/${fetchingKey}`
);

/** Placeholder reducer bez funkcionality */
export const emptyReducer: Reducer = (state: any = null, _action: any) => state;

/** Placeholder sága bez funkcionality */
export const emptySaga: SagaWithReturnType = function* emptySaga() {
    // záměrně prázdné
};
